import certificateService from "../../../apis/services/admin/certificateService";
import {
  FETCH_CERTIFICATES_ATTEMPT,
  FETCH_CERTIFICATES_SUCCESS,
  FETCH_CERTIFICATES_ERROR,
  FETCH_CERTIFICATES_RESET_STATE,
  DELETE_CERTIFICATE_ATTEMPT,
  DELETE_CERTIFICATE_SUCCESS,
  DELETE_CERTIFICATE_ERROR,
  DELETE_CERTIFICATE_RESET_STATE,
} from "../../actionTypes/actionTypes";

export const fetchCertificates = (page = 1, perPage = 10, term = "", sortBy = "id", order = "DESC") => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CERTIFICATES_ATTEMPT });
    try {
      const response = await certificateService.getCertificates(page, perPage, term, sortBy, order);
      dispatch({
        type: FETCH_CERTIFICATES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_CERTIFICATES_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteCertificate = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CERTIFICATE_ATTEMPT });
    try {
      const response = await certificateService.deleteCertificate(id);
      dispatch({
        type: DELETE_CERTIFICATE_SUCCESS,
        payload: { id, ...response.data },
      });
    } catch (error) {
      dispatch({
        type: DELETE_CERTIFICATE_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchCertificatesResetState = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_CERTIFICATES_RESET_STATE });
  };
};

export const deleteCertificateResetState = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_CERTIFICATE_RESET_STATE });
  };
};

